import React from "react";
import styles from "./PurchaseIncentives.module.scss";

export const PurchaseIncentives = ({ list }) => {
  return (
    <div className={styles.row}>
      {list.map((item, index) => (
        <div className={styles.card} key={index}>
          <h3>{item.title}</h3>
          <p>{item.description}</p>
        </div>
      ))}
    </div>
  );
};
